export const DEPARTMENT = "DEPARTMENT";
export const DEPARTMENT_SUCCESS = "DEPARTMENT_SUCCESS";
export const DEPARTMENT_FAILED = "DEPARTMENT_FAILED";

export const ADD_DEPARTMENT = "ADD_DEPARTMENT";
export const ADD_DEPARTMENT_SUCCESS = "ADD_DEPARTMENT_SUCCESS";
export const ADD_DEPARTMENT_FAILED = "ADD_DEPARTMENT_FAILED";

export const UPDATE_DEPARTMENT = "UPDATE_DEPARTMENT";
export const UPDATE_DEPARTMENT_SUCCESS = "UPDATE_DEPARTMENT_SUCCESS";
export const UPDATE_DEPARTMENT_FAILED = "UPDATE_DEPARTMENT_FAILED";